import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c836c5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["innerHTML"]

import { withDefaults } from "vue";
import { getTranslate, getImage } from "@/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardImageText',
  props: {
    image: null,
    imageLocal: { type: Boolean },
    imageWidth: { default: "20rem" },
    text: { default: "" },
    longText: { type: Boolean, default: false },
    font: { default: "Roboto" },
    fontSize: { default: "1rem" },
    invert: { type: Boolean, default: false },
    center: { type: Boolean, default: false },
    paddingBlock: { default: "1rem" },
    paddingInline: { default: "1rem" },
    background: { default: "transparent" }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "3ec73959": (__props.paddingBlock),
  "b3a67166": (__props.paddingInline),
  "631906cb": (__props.background),
  "5c0be6c8": (__props.imageWidth),
  "711515cd": (__props.fontSize)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass({ 'card-image-text': true, invert: __props.invert, center: __props.center })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _unref(getImage)(__props.image),
        alt: "image"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(['text', __props.font, __props.center ? 'center' : ''])
    }, [
      _createElementVNode("p", {
        innerHTML: _unref(getTranslate)(__props.text, __props.longText)
      }, null, 8, _hoisted_3)
    ], 2)
  ], 2))
}
}

})